export enum ReportDiffState {
  DONE = 'done',
  PENDING = 'pending',
  FAILED = 'failed',
}
